import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';


const NavLinks = ({ member, onLogout }) => {
    const linkClass = "px-2 xl:px-3 font-extrabold text-sm xl:text-base text-gray-500 hover:text-blue-900 whitespace-nowrap";
    return (
        <>
            <HashLink className={linkClass} smooth to="/#about">
                About
            </HashLink>
            <HashLink className={linkClass} smooth to="/#services">
                Services
            </HashLink>
            <Link className={linkClass} to="/network">
                The Network
            </Link>
            <Link className={linkClass} to="/programs">
                Programs
            </Link>
            <Link className={linkClass} to="/labs">
                Labs
            </Link>
            {member && (
                <Link className={linkClass} to="/scam-check">
                    🛡️ Scam Check
                </Link>
            )}
            {member && (
                <>
                    <Link className={linkClass} to="/it">
                        LAMNA 🦈
                    </Link>
                    <Link className={linkClass} to="/games">
                        Game Area
                    </Link>
                </>
            )}
            <Link className={linkClass} to="/faq">
                FAQ
            </Link>
            <Link className={linkClass} to="/remote">
                Remote Help
            </Link>
            {/* <HashLink className={linkClass} to="/">
                Our Mission
            </HashLink> */}
            {/* <HashLink className={linkClass} smooth to="/#about">
                Meet The Team
            </HashLink> */}
            <HashLink className={linkClass} to="/contact">
                Contact Us
            </HashLink>

            {member ? (
                /* Membership hub: last item on the far right, dropdown opens on its own hover only */
                <div className="relative group">
                    <Link
                        className={`${linkClass} text-blue-900 inline-flex items-center gap-1`}
                        to="/members"
                    >
                        Membership
                        <span className="text-xs transition-transform group-hover:rotate-180" aria-hidden="true">▾</span>
                    </Link>
                    <div className="absolute right-0 top-full pt-2 hidden group-hover:block z-50">
                        <div className="bg-white rounded-xl shadow-xl border border-gray-100 py-2 min-w-[180px]">
                            <Link
                                className="block px-4 py-2 text-sm font-bold text-gray-600 hover:text-blue-900 hover:bg-gray-50"
                                to="/members"
                            >
                                Member Area
                            </Link>
                            <Link
                                className="block px-4 py-2 text-sm font-bold text-gray-600 hover:text-blue-900 hover:bg-gray-50"
                                to="/resources"
                            >
                                Resources
                            </Link>
                            <Link
                                className="block px-4 py-2 text-sm font-bold text-gray-600 hover:text-blue-900 hover:bg-gray-50"
                                to="/transparency"
                            >
                                Transparency
                            </Link>
                            <button
                                onClick={onLogout}
                                className="block w-full text-left px-4 py-2 text-sm font-bold text-gray-600 hover:text-red-600 hover:bg-gray-50"
                            >
                                Logout ({member.username})
                            </button>
                        </div>
                    </div>
                </div>
            ) : (
                <Link className={linkClass} to="/membership">
                    Membership
                </Link>
            )}

            {/*
            <HashLink className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-auto px-6 py-3 shadow-xl rounded-xl" smooth to="/get-demo#demo">
                Demo our products
            </HashLink>
            */}
        </>
    )
}

export default NavLinks;
